import React, {memo} from 'react';
import cx from 'classnames';
import {Column} from '../../../stores/Form/Column';
import {isLtrStyle} from '../utils/direction';
import {StatusIcon} from './StatusIcon';
import styles from '../styles/direction.module.scss';

interface FormTextProps {
    value: string;
    column: Column;
}
export const FormText = memo((props: FormTextProps) => {
    const {value, column} = props;
    const stringVal = value || '';
    const isLtr = isLtrStyle(stringVal, column.Type);

    return (
        <div className={cx(styles.component, isLtr ? styles.ltrDirection : styles.rtlDirection)}>
            {column.IsStatus && stringVal && (
                <StatusIcon
                    statuses={column.parentForm.statuses}
                    status={stringVal}
                    isRtl={!isLtr}
                />
            )}
            {stringVal}
        </div>
    );
});
